import { useState } from 'react';
import { Helmet } from 'react-helmet';
import { 
  FaHome,
  FaPhone,
  FaWhatsapp,
  FaEnvelope,
  FaClock,
  FaMapMarkerAlt,
  FaSchool,
  FaBus,
  FaCalendarAlt,
  FaUserTie,
  FaUsers,
  FaMoneyBillWave,
  FaFileAlt,
  FaBirthdayCake,
  FaGraduationCap,
  FaCheckCircle,
  FaBook,
  FaRegClock
} from 'react-icons/fa';
import { title as siteTitle } from '../constants/constant';
import Layout from '../components/layout/Layout';
import BreadcrumbImg from '../assets/images/breadcrumb.png';
import { headerData } from '../data/headerData';

// Constants Data
const breadcrumbData = {
  home: { text: "Home", path: "/" },
  current: "Contact",
  title: "Contact Us",
  image: BreadcrumbImg
};

const contactCards = [
  {
    id: 1,
    title: "Call Us",
    value: headerData.contactInfo.phone.displayNumber,
    subtitle: "Office: 8 AM - 4 PM",
    icon: FaPhone,
    href: `tel:${headerData.contactInfo.phone.number}`,
    gradient: "from-blue-500 via-blue-400 to-cyan-500",
    hoverGradient: "from-blue-600 via-blue-500 to-cyan-600"
  },
  {
    id: 2,
    title: "WhatsApp",
    value: headerData.footer.whatsapp.display,
    subtitle: "10 AM - 4 PM",
    icon: FaWhatsapp,
    href: `https://wa.me/${headerData.footer.whatsapp.number}`,
    target: "_blank",
    gradient: "from-emerald-500 via-emerald-400 to-teal-500",
    hoverGradient: "from-emerald-600 via-emerald-500 to-teal-600",
    ping: true
  },
  {
    id: 3,
    title: "Email Us",
    value: headerData.contactInfo.email.displayEmail,
    subtitle: "Response in 24 hours",
    icon: FaEnvelope,
    href: `mailto:${headerData.contactInfo.email.address}`,
    gradient: "from-purple-500 via-purple-400 to-pink-500",
    hoverGradient: "from-purple-600 via-purple-500 to-pink-600"
  },
  {
    id: 4,
    title: "Office Hours",
    value: "Mon-Sat: 8AM-4PM",
    subtitle: "Sunday: Closed",
    icon: FaClock,
    gradient: "from-amber-500 via-amber-400 to-orange-500",
    hoverGradient: "from-amber-600 via-amber-500 to-orange-600"
  }
];

const quickInfoCards = [
  {
    id: 1,
    title: "School Timing",
    value: "Pre to Class 10: 8:30 AM to 2:30 PM",
    subtitle: "Summer/Winter timings vary",
    icon: FaClock,
    gradient: "from-blue-100 via-blue-50 to-white",
    borderColor: "border-blue-200",
    iconBg: "bg-white",
    iconColor: "text-blue-600"
  },
  {
    id: 2,
    title: "Transport Service",
    value: "Available for all areas",
    subtitle: "GPS buses with attendants",
    icon: FaBus,
    gradient: "from-emerald-100 via-emerald-50 to-white",
    borderColor: "border-emerald-200",
    iconBg: "bg-white",
    iconColor: "text-emerald-600"
  },
  {
    id: 3,
    title: "Admission Period",
    value: "December to March",
    subtitle: "Upcoming academic session",
    icon: FaCalendarAlt,
    gradient: "from-purple-100 via-purple-50 to-white",
    borderColor: "border-purple-200",
    iconBg: "bg-white",
    iconColor: "text-purple-600"
  },
  {
    id: 4,
    title: "Principal Office",
    value: "By appointment only",
    subtitle: "Meeting: 10 AM - 2 PM",
    icon: FaUserTie,
    gradient: "from-amber-100 via-amber-50 to-white",
    borderColor: "border-amber-200",
    iconBg: "bg-white",
    iconColor: "text-amber-600"
  }
];

const addressData = {
  schoolName: headerData.schoolInfo.name,
  subtitle: headerData.schoolInfo.subtitle,
  address: headerData.contactInfo.address.text,
  established: headerData.schoolInfo.establishedYear,
  description: `Established in ${headerData.schoolInfo.establishedYear}, ${headerData.schoolInfo.name} - ${headerData.schoolInfo.subtitle} provides quality CBSE education from Pre-Nursery to Class 10.`,
  icon: FaMapMarkerAlt,
  gradient: "from-blue-500 to-cyan-500"
};
const mapData = {
  title: "Gyan Rashmi Location",
  src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14431.578940773077!2d84.49256348972897!3d25.27412626629255!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x398d6d4d022961c9%3A0x526045d090322c26!2sNonadih%20road%20more!5e0!3m2!1sen!2sin!4v1771571815502!5m2!1sen!2sin",
  height: "100%",
  minHeight: "320px"
};

const visitInfoCards = [
  {
    id: 1,
    title: "Parents Meeting",
    value: "By prior appointment only",
    icon: FaUsers,
    gradient: "from-blue-50 to-blue-100",
    borderColor: "border-blue-200",
    iconBg: "bg-white",
    iconColor: "text-blue-600"
  },
  {
    id: 2,
    title: "Office Visit",
    value: "During office hours only",
    icon: FaRegClock,
    gradient: "from-emerald-50 to-emerald-100",
    borderColor: "border-emerald-200",
    iconBg: "bg-white",
    iconColor: "text-emerald-600"
  },
  {
    id: 3,
    title: "Admission Inquiry",
    value: "Bring student's documents",
    icon: FaFileAlt,
    gradient: "from-purple-50 to-purple-100",
    borderColor: "border-purple-200",
    iconBg: "bg-white",
    iconColor: "text-purple-600"
  },
  {
    id: 4,
    title: "Fee Payment",
    value: "Cash/Card/Cheque accepted",
    icon: FaMoneyBillWave,
    gradient: "from-amber-50 to-amber-100",
    borderColor: "border-amber-200",
    iconBg: "bg-white",
    iconColor: "text-amber-600"
  },
  {
    id: 5,
    title: "Student Admission",
    value: "Pre-Nursery to Class 10",
    icon: FaGraduationCap,
    gradient: "from-rose-50 to-rose-100",
    borderColor: "border-rose-200",
    iconBg: "bg-white",
    iconColor: "text-rose-600"
  },
  {
    id: 6,
    title: "Documents Required",
    value: "Birth Certificate & Marksheet",
    icon: FaBirthdayCake,
    gradient: "from-indigo-50 to-indigo-100",
    borderColor: "border-indigo-200",
    iconBg: "bg-white",
    iconColor: "text-indigo-600"
  }
];

export default function Contact() {
  return (
    <Layout>
      <Helmet>
        <title>Contact Us | {siteTitle}</title>
        <meta name="description" content="Get in touch with Gyan Rashmi. Find our address, phone numbers, email, and office hours. We're here to answer your queries." />
      </Helmet>

      {/* Breadcrumb Section */}
      <div className="relative bg-gray-900">
        <div className="h-40 md:h-48">
          <img 
            alt="Breadcrumb" 
            className="object-cover w-full h-full opacity-60" 
            src={breadcrumbData.image} 
          />
          <div className="absolute inset-0 bg-black/50"></div>
        </div>
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
          <div className="flex items-center mb-2 text-sm text-white">
            <a 
              href={breadcrumbData.home.path} 
              className="flex items-center transition-colors hover:text-gray-200"
            >
              <FaHome className="w-3 h-3 mr-1.5" />
              {breadcrumbData.home.text}
            </a>
            <span className="mx-2">/</span>
            <span className="font-semibold">{breadcrumbData.current}</span>
          </div>
          <h1 className="text-2xl font-bold text-white md:text-3xl">{breadcrumbData.title}</h1>
        </div>
      </div>

      {/* Main Content */}
      <div className="container px-4 py-6 mx-auto max-w-7xl md:py-8">
        {/* Intro Text */}
        <div className="max-w-3xl mx-auto mb-6 text-center">
          <p className="text-sm text-gray-700 md:text-base">
            Reach out to us for any inquiries about admissions, academics, or school facilities. 
            Our office staff is ready to assist you during working hours.
          </p>
        </div>

        {/* Contact Cards */}
        <div className="grid gap-3 mb-6 sm:grid-cols-2 lg:grid-cols-4">
          {contactCards.map((card) => (
            <a
              key={card.id}
              href={card.href || "#"}
              target={card.target || "_self"}
              rel={card.target === "_blank" ? "noopener noreferrer" : undefined}
              className="relative block p-4 overflow-hidden shadow-md cursor-pointer rounded-xl group"
            >
              {/* Background Gradient */}
              <div className={`absolute inset-0 bg-gradient-to-br ${card.gradient} group-hover:${card.hoverGradient} transition-all duration-500`}></div>
              
              {/* Hover Overlay */}
              <div className="absolute inset-0 transition-opacity duration-500 opacity-0 bg-white/10 group-hover:opacity-100"></div>
              
              {/* Shine Effect */}
              <div className="absolute inset-0 transition-transform duration-1000 -translate-x-full bg-gradient-to-r from-transparent via-white/30 to-transparent group-hover:translate-x-full"></div>
              
              {/* Ping Animation (for WhatsApp) */}
              {card.ping && (
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100">
                  <div className="absolute inset-0 m-2 rounded-full bg-white/20 animate-ping"></div>
                </div>
              )}
              
              {/* Content */}
              <div className="relative z-10">
                <div className="inline-flex items-center justify-center w-12 h-12 mb-2 text-white rounded-xl bg-white/20 backdrop-blur-sm">
                  <card.icon className="w-5 h-5" />
                </div>
                <h3 className="mb-0.5 text-sm font-bold text-white">{card.title}</h3>
                <p className="mb-0.5 text-sm font-semibold text-white">{card.value}</p>
                <p className="text-[10px] text-white/90">{card.subtitle}</p>
              </div>
            </a>
          ))}
        </div>

        {/* Quick Information */}
        <div className="mb-6">
          <div className="flex items-center justify-center gap-2 mb-4">
            <div className="w-6 h-1 rounded-full bg-gradient-to-r from-blue-500 to-cyan-500"></div>
            <h3 className="text-base font-bold text-center text-gray-900">Quick Information</h3>
            <div className="w-6 h-1 rounded-full bg-gradient-to-r from-cyan-500 to-blue-500"></div>
          </div>

          <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
            {quickInfoCards.map((card) => (
              <div 
                key={card.id}
                className={`relative rounded-xl p-4 border ${card.borderColor} bg-gradient-to-br ${card.gradient} shadow-sm overflow-hidden group`}
              >
                <div className="relative">
                  <div className="flex items-center gap-2 mb-2">
                    <div className={`p-1.5 ${card.iconBg} rounded-lg shadow-sm`}>
                      <card.icon className={`w-4 h-4 ${card.iconColor}`} />
                    </div>
                    <h4 className="text-xs font-bold text-gray-900">{card.title}</h4>
                  </div>
                  <p className="mb-0.5 text-xs font-medium text-gray-900">{card.value}</p>
                  <p className="text-[10px] text-gray-600">{card.subtitle}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Address and Map */}
        <div className="grid gap-4 mb-6 md:grid-cols-2">
          {/* Address Card */}
          <div className="relative p-5 overflow-hidden border border-blue-200 shadow-md bg-gradient-to-br from-blue-50 via-white to-cyan-50 rounded-xl">
            <div className="relative z-10">
              <div className="flex items-center gap-2 mb-3">
                <div className={`p-1.5 shadow-md rounded-lg bg-gradient-to-br ${addressData.gradient}`}>
                  <addressData.icon className="w-4 h-4 text-white" />
                </div>
                <div>
                  <h3 className="text-base font-bold text-gray-900">School Address</h3>
                  <p className="text-xs font-medium text-blue-600">{addressData.schoolName}</p>
                </div>
              </div>
              
              <div className="p-2 mb-3 bg-white border border-gray-100 rounded-lg">
                <p className="text-xs font-medium text-gray-800">{addressData.address}</p>
              </div>
              
              <div className="p-3 border border-blue-200 rounded-lg bg-gradient-to-r from-blue-100 to-cyan-100">
                <div className="flex items-center gap-1.5 mb-1.5">
                  <FaBook className="w-3 h-3 text-blue-600" />
                  <span className="text-xs font-bold text-gray-900">About Our School</span>
                </div>
                <p className="text-[10px] text-gray-700">
                  <strong className="text-blue-700">Established in {addressData.established}</strong>, {addressData.description}
                </p>
              </div>
            </div>
          </div>

          {/* Map */}
          <div className="overflow-hidden border border-gray-300 shadow-lg rounded-xl">
            <iframe
              title={mapData.title}
              src={mapData.src}
              width="100%"
              height={mapData.height}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="rounded-xl"
              style={{ border: 0, minHeight: mapData.minHeight }}
            ></iframe>
          </div>
        </div>

        {/* Visit Information */}
        <div>
          <div className="mb-4 text-center">
            <h3 className="mb-1 text-base font-bold text-gray-900">Visit Information</h3>
            <p className="max-w-2xl mx-auto text-xs text-gray-600">Important guidelines for visiting our school campus</p>
          </div>

          <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {visitInfoCards.map((card) => (
              <div 
                key={card.id}
                className={`relative rounded-xl p-4 border ${card.borderColor} bg-gradient-to-br ${card.gradient} shadow-sm overflow-hidden group`}
              >
                <div className="relative z-10">
                  <div className="flex items-center gap-2 mb-2">
                    <div className={`p-1.5 ${card.iconBg} rounded-lg shadow-sm`}>
                      <card.icon className={`w-4 h-4 ${card.iconColor}`} />
                    </div>
                    <h4 className="text-xs font-bold text-gray-900">{card.title}</h4>
                  </div>
                  <p className="text-xs text-gray-700">{card.value}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
}